import styled, { css } from "styled-components";
import {
  EmailTitleWrapper,
  TitleWrapper
} from "../Step1Setup/styles";
import { Err } from "../Step1Setup/styles";
import { ErrorMessage } from "../../../../CommonComponents/commonStyles";

const fontCommonStyles = css`
  font-family: HelveticaNeue;
  font-size: 16px;
  color: #505050;
`;

export const Heading = styled.div`
  font-family: HelveticaNeue-Bold;
  font-size: 16px;
  line-height: 1.5;
  color: #022737;
  margin-bottom: ${props => props.marginBottom};
`;

export const BestowHeading = styled(Heading)`
  font-family: HelveticaNeue-Medium;
  letter-spacing: 0.5px;
  font-size: 18px;
`;

export const SubHead = styled.div`
  ${fontCommonStyles}
  line-height: 1.5;
  margin-bottom: -4px;
  letter-spacing: 0.6px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const SuccessionSubhead = styled(SubHead)`
  margin-top: 15px;
  margin-bottom: 30px;
`;

export const EndowHeading = styled(Heading)`
  padding-top: 10px;
`;

export const FundNameWrap = styled.div`
  display: flex;
  margin-bottom: 26px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 16px;
  }
`;

export const FundLeft = styled.div`
  ${fontCommonStyles}
  line-height: 1.5;
  margin: 26px 20px 0 0;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 30px 10px 0 0;
  }
`;
export const FundRight = styled.span`
  ${fontCommonStyles}
  line-height: 1.5;
  margin: 26px 0 0 20px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 30px 0 0 10px;
  }
`;

export const InputWrap = styled.div`
  .ant-input {
    width: 355px;
    height: 40px;
    border-radius: 0;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      width: 231px;
    }
  }
`;

export const Content = styled.div`
  ${fontCommonStyles}
  letter-spacing: 0.57px;
  padding: 7px 0 30px 18px;
  width: 700px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 7px 0 30px 20px;
    font-size: 14px;
    width: 273px;
  }
`;

export const MainWrapper = styled.div`

`;

export const PercentageWrapper = styled(MainWrapper)`
  margin-bottom: 16px;
`;
export const EmailTitleWrapperFont = styled(EmailTitleWrapper)`
  margin-top: 16px;
  margin-bottom: 10px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
    margin-top: 14px;
  }
`;

export const PercentageTitle = styled(EmailTitleWrapperFont)`
  margin-top: 0;
`;

export const TitleWrapperFont = styled(TitleWrapper)`
  margin-bottom: 10px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const ErrMargin = styled(ErrorMessage)`
  margin-top: -20px;
`;

export const MarginComponent = styled.div`
  margin-top: 10px;
`;

export const MarginComponentDrop = styled.div`
  margin-top: 16px;
`;


export const SpanWrap = styled.span`
span{
  font-weight:normal;
  font-family: HelveticaNeue;
  color: #505050;
  font-size: 16px;
}
  
`
export const ErrMarginZipCode = styled(ErrorMessage)`
  margin-top: 4px;
  line-height: ${props => props.theme.lineHeight.primary} !important;
`;